const data = [
  {
    department: "Research",
    AnnualPay: 1500000,
  },
  {
    department: "Accounting",
    AnnualPay: 1500000,
  },
  {
    department: "Management",
    AnnualPay: 1500000,
  },
  {
    department: "Production",
    AnnualPay: 1500000,
  },
  {
    department: "Labour",
    AnnualPay: 1500000,
  },
  {
    department: "Marketing",
    AnnualPay: 1500000,
  },
  {
    department: "Product Management",
    AnnualPay: 1500000,
  },
];

module.exports = data
